<script lang="ts">
  import { fade } from "svelte/transition";
  import { onMount } from "svelte";
  import Uploader from "./Uploader.svelte";
  import type { IS3Object } from "../types/index";
  import BackEnd from "../lib/BackEnd";
import Utils from "../lib/Utils";

  const uplProps = {
    actionURL: process.env.isProd ? "/upload" : "http://localhost:3005/upload",
    autoupload: true,
    onUpload: () => reload(),
    access_token: BackEnd.getAccessToken(),
  };
  let caseList: IS3Object[] = [];

  const reload = async () => {
    BackEnd.getCaseList().then((ok) => {
      caseList = ok
        .map((i: IS3Object) => {
          let path = i.Key.split("/");
          i._filename = path[path.length - 1];
          i._cat = new Date(i.LastModified);
          return i;
        })
        .sort((a, b) => b._cat - a._cat);
    });
  };
  onMount(() => reload());
</script>

<main in:fade>
  <h1>File Exchange</h1>
  <center><Uploader props={uplProps} /></center>
  <div class="List">
    {#each caseList as item}
      <div
        class="ListItem"
        on:click={() => {
          //window.open(BackEnd.getCaseByKeyUrl(item.Key), "S3File");
        }}
      >
        <div>{item._filename}</div>
        <div>{Utils.bytesToSize(item.Size)}</div>
        <div>{item._cat.toLocaleString()}</div>
      </div>
    {/each}
  </div>
</main>

<style>
  div.List {
    border-radius: 0.5rem;
    margin-top: 1rem;
    display: block;
    border: solid 1px lightgrey;
    background-color: var(--bg-grey);
    height: 800px;
    overflow-y: auto;
    cursor: pointer;
  }
  div.List .ListItem {
    display: flex;
    background-color: white;
    align-items: stretch;
    padding-top: 1rem;
    transition: all ease-in-out 0.5s;
    margin: 0.3rem;
    border-radius: 0.2rem;
    justify-content: space-between;
  }

  div.List .ListItem:hover {
    background-color: var(--bg-blue);
    /*  background-color: rgba(0, 0, 0, 0.02);*/
    transition: all ease-in-out 0.5s;
  }

  .ListItem div {
    padding: 1rem;
    text-align: left;
  }

  .ListItem div:last-child {
    text-align: right;
    color: grey;
    font-size: 0.8rem;
    padding-right: 0.8rem;
  }
  main {
    text-align: center;
    max-width: 250px;
    margin: 0 auto;
    padding: 1rem;
  }

  h1 {
    color: var(--main-red);
    text-transform: uppercase;
    font-size: 2em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
